import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import { RouterModule } from '@angular/router';
import { ApplicationPaths } from './api-authorization.constants';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(
      [
        { path: 'en/' + ApplicationPaths.Register, redirectTo: ApplicationPaths.Register },
        { path: ApplicationPaths.Register, component: LoginComponent },
        { path: 'en/' + ApplicationPaths.Login, redirectTo: ApplicationPaths.Login },
        { path: ApplicationPaths.Login, component: LoginComponent },
        { path: 'en/' + ApplicationPaths.LoginFailed, redirectTo: ApplicationPaths.LoginFailed },
        { path: ApplicationPaths.LoginFailed, component: LoginComponent },
        { path: 'en/' + ApplicationPaths.LoginCallback, redirectTo: ApplicationPaths.LoginCallback },
        { path: ApplicationPaths.LoginCallback, component: LoginComponent },
        { path: 'en/' + ApplicationPaths.LogOut, redirectTo: ApplicationPaths.LogOut },
        { path: ApplicationPaths.LogOut, component: LogoutComponent },
        { path: 'en/' + ApplicationPaths.LoggedOut, redirectTo: ApplicationPaths.LoggedOut },
        { path: ApplicationPaths.LoggedOut, component: LogoutComponent },
        { path: 'en/' + ApplicationPaths.LogOutCallback, redirectTo: ApplicationPaths.LogOutCallback },
        { path: ApplicationPaths.LogOutCallback, component: LogoutComponent },
        { path: 'en/' + ApplicationPaths.RegisterChildUser, redirectTo: ApplicationPaths.RegisterChildUser },
        { path: ApplicationPaths.RegisterChildUser, component: LoginComponent}
      ]
    )
  ],
  declarations: [],
  exports: []
})
export class ApiAuthorizationModule { }
